package de.oevbs.kunde.kundenportal2.services.lifeValueNotification

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.LifeContract
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.LifeValueNotification
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.lifeContracts
import de.oevbs.kunde.kundenportal2.model.services.lifeValueNotification.selectedContracts
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.lifeValueNotification.store.LifeValueStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import kotlinx.coroutines.flow.combine

fun RenderContext.lifeValueStart() {

    val store = LifeValueStore(job)

    headerImageLayout {
        title("Wertstandsmitteilung anfordern")
        content {
            renderLifeValue(store)
        }
    }
}

private fun RenderContext.renderLifeValue(store: LifeValueStore) {

    store.currentStep.render { step ->

        GlobalServiceMessagesStore.clear()

        when (step) {
            GeneralProgressStep.SUBMIT1 -> lifeValueStep1(store)
            GeneralProgressStep.SUCCESS2 -> {
                messagePagePre(
                    header = "Erfolgreich angefordert",
                    preContent = PortalContactNotes.LifeValueNotificationRequestedAllContracts(
                        store.current.selectedContracts
                    ).note
                )
            }
        }
    }
}

private fun RenderContext.lifeValueStep1(store: LifeValueStore) {
    contentContainer {
        store.init()
        globalInitTracker.data.combine(store.initFailedFlow, ::Pair).render { (loading, failed) ->
            if (loading) return@render
            when {
                failed -> noContractDataFoundMessage()
                else -> showUi(store)
            }
        }
    }
}

private fun RenderContext.showUi(store: LifeValueStore) {

    val contractsSub = store.map(LifeValueNotification.lifeContracts())

    contractsSub.data.render contractsList@{ contracts ->
        if (contracts.isEmpty()) {
            messageCardWithContent(
                "Sie haben keine Lebensversicherungen bei uns, für die Wertstandsmitteilungen angefordert werden können. Möchten Sie das ändern? Melden Sie sich bei Ihrer Beraterin oder Ihrem Berater."
            ) {
                btn {
                    label("Mitteilung schreiben")
                }.clicks handledBy { Pages.contactMessage.visit() }
            }
            return@contractsList
        }


        paragraph {
            +"Zu Lebens- und Rentenversicherungen senden wir Ihnen jährlich Wertstandsmitteilungen,"
            +" die den Vertragsstand und die Wertentwicklung zeigen. In der "
            textualButton("Vertragsübersicht") handledBy { Pages.contractsList.visit() }
            +" können Sie die Vertragsdetails zu jedem Ihrer Verträge aufrufen, um den Zeitpunkt"
            +" der letzten Wertstandsmitteilung einzusehen."
        }
        paragraph {
            +"Zusätzlich können Sie hier eine aktuelle Wertstandsmitteilung anfordern, die Ihnen dann in den nächsten"
            +" Tagen per Post zugestellt wird. Dies ist jedoch nicht für alle Verträge möglich - bitte "
            textualButton("kontaktieren Sie uns") handledBy { Pages.contactMessage.visit() }
            +", wenn Sie einen Vertrag in der folgenden Liste vermissen."
        }

        sectionHeader("Vertrag auswählen")

        card {
            buttonToggleKupo<LifeContract> {
                value.multi(store.map(LifeValueNotification.selectedContracts()))
                options = contractsSub.current
                optionsFormat = { c ->
                    buildList {
                        if (c.branchGroup.isNotBlank()) add(c.branchGroup)
                        add(c.contractNumber)
                    }
                }
            }
        }

        buttonContainer {
            btn {
                label("Anfordern")
                busy(globalSubmitTracker.data)
            }.clicks handledBy store.requestValueNotification
        }
    }
}